import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressBook, faBank, faBook, faCartShopping, faFileInvoice, faHome, faReceipt, faRightFromBracket, faShoppingCart, faTruckArrowRight, faUser, faUsers } from '@fortawesome/free-solid-svg-icons'
import { ActionCreators } from 'store/actionCreators';
import { useDispatch } from 'react-redux';
import swal from 'sweetalert';
import { AuthSession } from 'service/AuthSession';


export const BottomBar = () => {
    const dispatch = useDispatch();

    const confirmLogout = () => {
        swal({
            title: "Confirm logout",
            text: "Are you sure you want to logout?",
            icon: "warning",
            dangerMode: true,
            buttons: {
                default: { text: 'Cancel' },
                cancel: { text: 'Cancel' },
                confirm: { text: 'Logout' }
            }
          })
                    .then(async (confirmLogout) => {
            if (confirmLogout === true) {
                                await AuthSession.clear();
                dispatch(ActionCreators.logout());
            }
          });
    }

    return (
        <>
            <nav className="navbar fixed-bottom navbar-light bg-light app-bottom-bar">                
                <li className="nav-item" title="Home">
                    <NavLink to="/">
                        <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                </li>
                <li className="nav-item"  title="Orders">
                    <NavLink to="/invoices">
                        <FontAwesomeIcon icon={faShoppingCart} />
                    </NavLink>
                </li>     
                <li className="nav-item"  title="Receipts">
                    <NavLink to="/receipts">
                        <FontAwesomeIcon icon={faReceipt} />
                    </NavLink>
                </li>  
                <li className="nav-item"  title="Customers">
                    <NavLink to="/customers">
                        <FontAwesomeIcon icon={faUsers} />
                    </NavLink>
                </li>
                <li className="nav-item" title="Logout">
                    <button type='button' onClick={confirmLogout} className='btn p-0 border-0 bg-transparent'>
                        <FontAwesomeIcon icon={faRightFromBracket} />
                    </button>
                </li>   
            </nav>
        </>
    )
};
